import {
  IParamsAddEmployee,
  IParamsGetAllTeamSalesDetail,
  IParamsUpdateManyEmployee,
} from 'interfaces/TeamSaleDetail/TeamSaleDetail';

export const TEAMSALE_DETAIL_VARIABLE = {
  getAllTeamSaleDetailsById: (params: IParamsGetAllTeamSalesDetail) => {
    return {
      input: {
        ...(params.teamSaleId && { teamSaleId: { equals: params.teamSaleId } }),
        ...(params.useYn && { useYn: { equals: params.useYn } }),
      },
    };
  },
  createEmployeeTS: (params: IParamsAddEmployee) => {
    const { sloc, userId, teamSaleId, useYn, leaderYn, startDate, endDate } =
      params;
    return {
      data: {
        sloc,
        userId,
        teamSaleId,
        useYn,
        leaderYn,
        startDate,
        endDate,
      },
    };
  },
  createManyEmployeeTS: (params: IParamsAddEmployee[]) => {
    return { input: params };
  },
  updateManyEmployeeTS: (params: IParamsUpdateManyEmployee[]) => {
    return {
      input: params,
    };
  },
  deleteManyEmployeeTS: (ids: string[]) => {
    return {
      input: {
        id: ids,
      },
    };
  },
};
